import { Link, useRouterState } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useFooterLoading } from './use-footer-loading'
import { SUPPORT_EMAIL } from '@/shared/config/support'
import { useIsNetworkBusy } from '@/shared/lib/network-activity'

const linkClassName =
  'underline-offset-4 hover:text-foreground hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'

const iconLinkClassName =
  'group hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'
const TELEGRAM_URL = 'https://t.me/amitablebot'
const MAX_URL = 'https://max.ru/id774318706487_bot'

function TelegramIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-4" fill="currentColor" aria-hidden>
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  )
}

function MaxIcon() {
  return (
    <img
      src="/max-icon.png"
      alt=""
      aria-hidden
      className="size-4 rounded-[4px] opacity-60 grayscale transition group-hover:opacity-100 group-focus-visible:opacity-100"
    />
  )
}

export function AppFooter() {
  const { t } = useTranslation()
  const networkBusy = useIsNetworkBusy()
  const routerPending = useRouterState({
    select: (state) => state.status === 'pending',
  })
  const loading = useFooterLoading(networkBusy || routerPending)

  return (
    <footer
      aria-busy={loading}
      className="relative isolate shrink-0 overflow-hidden border-t border-border bg-background bg-[radial-gradient(circle_at_bottom_right,color-mix(in_oklab,var(--color-primary)_12%,transparent),transparent_60%)] px-4 py-1.5 text-xs text-muted-foreground"
    >
      <div
        aria-hidden
        data-testid="footer-gradient-overlay"
        data-loading={loading}
        className="footer-gradient-overlay pointer-events-none absolute inset-0 -z-10"
      />
      <div className="relative flex flex-wrap items-center justify-between gap-x-4 gap-y-1 sm:min-h-5">
        <span className="flex items-center gap-2">
          <span>Amitable © {new Date().getFullYear()}</span>
          <span aria-hidden="true">•</span>
          <Link to="/settings/legal" className={linkClassName}>
            {t('common:legalDocuments')}
          </Link>
        </span>
        <div className="flex items-center gap-3">
          <a href={`mailto:${SUPPORT_EMAIL}`} className={linkClassName}>
            {SUPPORT_EMAIL}
          </a>
          <a
            href={TELEGRAM_URL}
            aria-label="Telegram"
            className={iconLinkClassName}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TelegramIcon />
          </a>
          <a
            href={MAX_URL}
            aria-label="MAX"
            className={iconLinkClassName}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MaxIcon />
          </a>
        </div>
      </div>
    </footer>
  )
}
